import { render, staticRenderFns } from "./sandbox.vue?vue&type=template&id=3162b41a&scoped=true&"
import script from "./sandbox.vue?vue&type=script&lang=js&"
export * from "./sandbox.vue?vue&type=script&lang=js&"
import style0 from "./sandbox.vue?vue&type=style&index=0&id=3162b41a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3162b41a",
  null
  
)

export default component.exports